import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, retry, throwError } from 'rxjs';
import { faro } from '@grafana/faro-web-sdk';
import { environment } from 'src/environments/environment';
import { SnackbarService } from './snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ApiSentrynelService {
  private baseUrl: string = environment.apiSentrynelUrl;
  private httpOptions: {
    body?: any;
    headers: {
      [header: string]: string | string[];
    };
    context?: HttpContext;
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'json';
    withCredentials?: boolean;
  } = {
    headers: {'Content-Type': 'application/json'},
    responseType: 'json'
  };

  constructor(
    private http: HttpClient,
    private snackbar: SnackbarService,
  ) {}

  public get<T>(url: string, retryCount: number = 0): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${url}`, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public post<T>(url: string, data: any, retryCount: number = 0): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${url}`, data, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public put<T>(url: string, data: any, retryCount: number = 0): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${url}`, data, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public delete<T>(url: string, retryCount: number = 0): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}/${url}`, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public setHeader(key: string, value: string | undefined) {
    if (value) {
      if (this.httpOptions.headers) {
        this.httpOptions.headers[key] = value;
      } else {
        this.httpOptions.headers = {
          key: value
        };
      }
    } else {
      delete this.httpOptions.headers[key];
    }
  }

  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else if (error.error.listaErrori) {
      // Get server-side error
      error.error.listaErrori.forEach((errorItem: { codiceErrore: string, descrizioneErrore: string }) => {
        this.snackbar.error(`Errore: ${errorItem.descrizioneErrore}`);
      });
    } else if (error.error.codiceErrore) {
      this.snackbar.error(`Errore: ${error.error.descrizioneErrore}`);
    } else if (error.error.error) {
      this.snackbar.error(`Errore: Mi dispiace, qualcosa non va. <br>(${error.error.status} - ${error.error.error})`)
    } else {
      this.snackbar.error(`Errore: Mi dispiace, il server non risponde.`)
    }

    faro?.api?.pushError(new Error(errorMessage));
    return throwError(() => {
      return errorMessage;
    });
  }
}
